import Axios from "../config/config";


export const Add_LIVE_TEST_QUESTION = async (body) => {
    try {
        const response = await Axios.post('add-test-question/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const EDIT_LIVE_TEST_QUESTION = async (body) => {
    try {
        const response = await Axios.post('edit-test-question/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};
export const VIEW_LIVE_TEST_QUESTION = async (body) => {
    try {
        const response = await Axios.post('view-test-question/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LIST_LIVE_TEST_QUESTION = async (body) => {
    try {
        const response = await Axios.post('list-test-question/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const DELETE_LIVE_TEST_QUESTION = async (body) => {
    try {
        const response = await Axios.post('delete-live-test-question/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};